"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.localeSlice = exports.sessionSlice = exports.setAdditionalDefaultHeaders = exports.getBrowserDefaultLanguage = exports.DEVICE_ENV_KEY = exports.SESSION_COOKIE_DOMAIN = exports.LOCALE_LANG_COOKIE_KEY = exports.LOCALE_LANG_KEY = exports.SESSION_KEY = exports.DEVICE_KEY = exports.deleteCookie = exports.getCookie = exports.setCookie = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const flax_1 = require("@coralblack/flax");
const common_1 = require("../../consts/common");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const log = (...args) => (process.env.REACT_APP_STAGE === "shared" || process.env.REACT_APP_STAGE === "local" || process.env.REACT_APP_STAGE === "develop") &&
    // eslint-disable-next-line no-console
    console.log(...args);
// Set baseUrl
(0, flax_1.setBaseUrl)(process.env.REACT_APP_CDMS_BE_URL || process.env.REACT_APP_CDMS_URL || process.env.REACT_APP_SERVICE_HOST || "http://127.0.0.1");
// Cookie Helper
const COOKIE_DEFAULT_PATH = "/";
// Set cookie
const setCookie = (key, value, expiryAt, opts) => {
    const options = [
        (opts === null || opts === void 0 ? void 0 : opts.domain) ? `domain=${opts.domain};` : "",
        (opts === null || opts === void 0 ? void 0 : opts.secure) ? "Secure;" : "",
        (opts === null || opts === void 0 ? void 0 : opts.sameSite) ? `SameSite=${opts.sameSite};` : "",
        `expires=${expiryAt.toUTCString()};`,
        `path=${COOKIE_DEFAULT_PATH};`,
    ].filter(e => e);
    document.cookie = `${key}=${encodeURIComponent(value)}; ${options.join(" ")}`;
};
exports.setCookie = setCookie;
// Get cookie
const getCookie = (key) => {
    const cookie = document.cookie.match("(^|;)\\s*" + key + "\\s*=\\s*([^;]+)");
    const found = cookie ? cookie.pop() : "";
    return decodeURIComponent(found);
};
exports.getCookie = getCookie;
// Delete cookie
const deleteCookie = (key, opts) => {
    const options = [(opts === null || opts === void 0 ? void 0 : opts.domain) ? `domain=${opts.domain};` : "", `path=${COOKIE_DEFAULT_PATH};`].filter(e => e);
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; ${options.join(" ")}`;
};
exports.deleteCookie = deleteCookie;
const appStage = process.env.REACT_APP_STAGE || process.env.VITE_APP_STAGE;
const featureLangCookieEnabled = (process.env.REACT_APP_FEATURE_LANG_COOKIE || process.env.VITE_APP_FEATURE_LANG_COOKIE) === "true";
exports.DEVICE_KEY = "cream:auth:device:key";
exports.SESSION_KEY = "cream:auth";
exports.LOCALE_LANG_KEY = "LoLang";
exports.LOCALE_LANG_COOKIE_KEY = `cream:lang:${appStage}`;
exports.SESSION_COOKIE_DOMAIN = ".mavenclinical.com";
exports.DEVICE_ENV_KEY = `${exports.DEVICE_KEY}:${process.env.REACT_APP_STAGE || process.env.VITE_APP_STAGE}`;
const SESSION_COOKIE_KEY = `${exports.SESSION_KEY}:${process.env.REACT_APP_STAGE || process.env.VITE_APP_STAGE}`;
const stored = localStorage.getItem(exports.SESSION_KEY) || (0, exports.getCookie)(SESSION_COOKIE_KEY);
const getBrowserDefaultLanguage = () => {
    switch (navigator.language.toLocaleLowerCase()) {
        case "ko":
        case "ko-kr":
            return common_1.LoLang.KO;
        case "fr":
        case "fr-fr":
            return common_1.LoLang.FR;
        case "nl":
        case "nl-nl":
            return common_1.LoLang.NL;
        default:
            return common_1.LoLang.EN;
    }
};
exports.getBrowserDefaultLanguage = getBrowserDefaultLanguage;
if (!featureLangCookieEnabled && !localStorage.getItem(exports.LOCALE_LANG_KEY)) {
    localStorage.setItem(exports.LOCALE_LANG_KEY, (0, exports.getBrowserDefaultLanguage)());
}
const language = !featureLangCookieEnabled
    ? localStorage.getItem(exports.LOCALE_LANG_KEY)
    : (0, exports.getCookie)(exports.LOCALE_LANG_COOKIE_KEY) || (0, exports.getBrowserDefaultLanguage)();
const initialState = Object.assign({
    token: null,
    expiryAt: null,
}, stored ? JSON.parse(stored) : {});
const localeInitialState = Object.assign({ lolang: common_1.LoLang.KO }, language ? { lolang: language } : {});
(_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", String(localeInitialState.lolang).toLowerCase());
const configurableDefaultHeaders = (headers) => Object.assign({
    Authorization: initialState.token,
    Lang: language || common_1.LoLang.KO,
    "Timezone-Offset": -new Date().getTimezoneOffset(),
}, headers || {});
(0, flax_1.setDefaultHeaders)(configurableDefaultHeaders());
const setAdditionalDefaultHeaders = (headers) => (0, flax_1.setDefaultHeaders)(headers);
exports.setAdditionalDefaultHeaders = setAdditionalDefaultHeaders;
const storeSessionCookie = (stringifiedPayload, expiryAt) => {
    const isLocal = !window.location.protocol.startsWith("https");
    (0, exports.setCookie)(SESSION_COOKIE_KEY, stringifiedPayload, new Date(expiryAt), {
        domain: exports.SESSION_COOKIE_DOMAIN,
        secure: !isLocal,
        sameSite: !isLocal ? "None" : undefined,
    });
};
exports.sessionSlice = (0, toolkit_1.createSlice)({
    name: "session",
    initialState,
    reducers: {
        signIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            const stringifiedPayload = JSON.stringify({ ...state, redirectTo: undefined });
            storeSessionCookie(stringifiedPayload, state.expiryAt);
            localStorage.setItem(exports.SESSION_KEY, stringifiedPayload);
            if (action.payload.redirectTo) {
                if (action.payload.redirectTo.includes(":")) {
                    // eslint-disable-next-line @typescript-eslint/no-unused-vars
                    const [_, restProtocol] = action.payload.redirectTo.split(":");
                    const [hostname] = (restProtocol || "").slice(2).split("/");
                    const domain = String((hostname || "").split(".").slice(-2)[0]).toLowerCase(); // TLD는 1차(.com, .dev, .io, ..)만으로 간주함
                    if (!["mavencdms", "mavenclinical"]
                        .concat(["local", "shared"].includes(appStage) ? ["localhost", "127.0.0.1"] : [])
                        .includes(domain)) {
                        log(`sessionSlice:signIn, Redirection Host Not Allowed, (${domain})`);
                        document.location.href = "/";
                        return;
                    }
                }
                log(`sessionSlice:signIn, Redirect to (${action.payload.redirectTo})`);
                document.location.href = action.payload.redirectTo;
            }
            else {
                log("sessionSlice:signIn, Reload.");
                document.location.reload();
            }
        },
        signOut(state) {
            state.token = null;
            state.expiryAt = null;
            localStorage.removeItem(exports.SESSION_KEY);
            (0, exports.deleteCookie)(SESSION_COOKIE_KEY, { domain: exports.SESSION_COOKIE_DOMAIN });
            document.location.href = "/";
        },
        refreshSignIn(state, action) {
            state.token = action.payload.authToken.token;
            state.expiryAt = action.payload.authToken.expiryAt;
            const stringifiedPayload = JSON.stringify({ ...state, redirectTo: undefined });
            storeSessionCookie(stringifiedPayload, state.expiryAt);
            localStorage.setItem(exports.SESSION_KEY, stringifiedPayload);
            (0, flax_1.setDefaultHeaders)(configurableDefaultHeaders({ Authorization: action.payload.authToken.token }));
        },
        updateExpiryAt(state, action) {
            state.expiryAt = action.payload.authToken.expiryAt;
            const stringifiedPayload = JSON.stringify({ ...state, redirectTo: undefined });
            storeSessionCookie(stringifiedPayload, state.expiryAt);
            localStorage.setItem(exports.SESSION_KEY, stringifiedPayload);
        },
    },
});
exports.localeSlice = (0, toolkit_1.createSlice)({
    name: "locale",
    initialState: localeInitialState,
    reducers: {
        changeLocaleLanguage(state, action) {
            var _a;
            state.lolang = action.payload.lolang;
            localStorage.setItem(exports.LOCALE_LANG_KEY, state.lolang);
            (_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.setAttribute("lang", String(state.lolang).toLowerCase());
        },
    },
});
//# sourceMappingURL=session.js.map